export default __webpack_public_path__ + "static/media/diary.d6286fce.svg";